<div class="card m-0 bg-transparent">
  <div class="card-body">
    <div class="row align-items-center" [class.mt-4]="config?.text">
      <label for="bg-color" class="offcanvas-header-text col-9 m-0" style="text-align: left">
        Background Gradient
      </label>
      <div *ngIf="!enableCustomGradientColor" class="col-3 d-flex justify-content-end">
        <btn class="btn btn-primary" (click)="toggleGradientColor(true)">SET</btn>
      </div>
      <div *ngIf="enableCustomGradientColor"
        class="col-3 text-start mt-2 d-flex align-items-center justify-content-end">
        <span class="offcanvas-danger-text enablePointer" (click)="toggleGradientColor(false)">
          Remove
        </span>
      </div>
      <ng-container *ngIf="enableCustomGradientColor">
        <div class="col-6 mt-2">
          <div class="input-group offcanvas-border-primary border rounded-2" title="Using format option">
            <input type="text" id="bg-color" class="form-control input-lg offcanvas-primary border-0"
              (change)="startColorChange($event, true, 'color')" [value]="startColor"
              [readOnly]="!enableCustomGradientColor" />
            <span class="input-group-text p-1 border-0 offcanvas-primary">
              <span class="input-group-text colorpicker-input-addon h-100" [style.background]="startColor"
                [cpOutputFormat]="'hex'" [(colorPicker)]="startColor" [cpPosition]="'auto'"
                (colorPickerChange)="startColorChange($event, false, 'color')"
                [cpDisabled]="!enableCustomGradientColor">
              </span>
            </span>
          </div>
        </div>
        <div class="col-6 mt-2">
          <div class="input-group offcanvas-border-primary border rounded-2" title="Using format option">
            <input type="text" id="bg-color" class="form-control input-lg offcanvas-primary border-0"
              (change)="endColorChange($event, true, 'color')" [value]="endColor"
              [readOnly]="!enableCustomGradientColor" />
            <span class="input-group-text p-1 border-0 offcanvas-primary">
              <span class="input-group-text colorpicker-input-addon h-100" [style.background]="endColor"
                [cpOutputFormat]="'hex'" [(colorPicker)]="endColor" [cpPosition]="'auto'"
                (colorPickerChange)="endColorChange($event, false, 'color')" [cpDisabled]="!enableCustomGradientColor">
              </span>
            </span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>